import { createContext, useContext, useState, ReactNode } from 'react';

interface TemporaryRequestContextType {
  requestId: string | null;
  publicKey: string | null;
  setRequestId: (requestId: string) => void;
  setPublicKey: (publicKey: string) => void;
}

const TemporaryRequestContext = createContext<TemporaryRequestContextType>({
  requestId: null,
  publicKey: null,
  setRequestId: () => {},
  setPublicKey: () => {},
});

export const TemporaryRequestProvider = ({ children }: { children: ReactNode }) => {
  const [requestId, setRequestId] = useState<string | null>(null);
  const [publicKey, setPublicKey] = useState<string | null>(null);

  return (
    <TemporaryRequestContext.Provider value={{ requestId, publicKey, setRequestId, setPublicKey }}>
      {children}
    </TemporaryRequestContext.Provider>
  );
};

export const useTemporaryRequest = () => useContext(TemporaryRequestContext);
